import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Facility } from "../models/facility"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FacilityService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'facility/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllFacility(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Facility>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllFacility?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewFacility(FacilityID?: string): Observable<Array<Facility>> {
    return this.httpService.get(this.apiEndpoint + 'viewFacility/' + (FacilityID ? FacilityID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveFacility(facilitys: Facility): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveFacility/', facilitys).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  } 

  deleteFacility(FacilityID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteFacility/' + (FacilityID ? FacilityID : '00000000-0000-0000-0000-000000000000'), FacilityID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(FacilityName?: string,FacilityId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?FacilityName=' + (FacilityName ? FacilityName : '')+ '&FacilityId=' + (FacilityId ? FacilityId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
